import { render } from "./CompliancePage.vue?vue&type=template&id=bf57d48a&scoped=true"
import script from "./CompliancePage.vue?vue&type=script&lang=js"
export * from "./CompliancePage.vue?vue&type=script&lang=js"

import "./CompliancePage.vue?vue&type=style&index=0&id=bf57d48a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf57d48a"]])

export default __exports__